import {Component, OnDestroy, OnInit} from '@angular/core';
import {debounceTime, Subject, takeUntil} from 'rxjs';
import {DropdownOption} from '../../../../../../models/dropdown-option.model';
import * as Validation
  from '../../../../../shared/constants/validation.constants';
import {FormControl, FormGroup} from '@angular/forms';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../../state/app.state';
import {CommonService} from '../../../../../shared/services/common.service';
import {
  FetchGroupListFilterRequest,
  FetchUserStatusListFilterRequest
} from '../../../core/admin-groups-list.actions';
import {
  groupListFilter,
  userStatusListFilter
} from '../../../core/admin-groups-list.selectors';

import {Filter} from '../../../../../../models/filter';
import {
  AdminGroupListService
} from '../../../services/admin-group-list.service';
import {roles} from '../../../../../shared/constants/common.constants';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-participant-weight-information-filter',
  templateUrl: './participant-weight-information-filter.component.html',
  styleUrls: ['./participant-weight-information-filter.component.css']
})
export class ParticipantWeightInformationFilterComponent implements OnInit,
                                                                    OnDestroy {

  sessionFilterList: DropdownOption[] = [
    {
      key: 1,
      value: 'Up to S26',
    },
    {
      key: 2,
      value: 'After S26',
    },
  ];

  roleFilterList: DropdownOption[] = [
    {
      key: roles.adult,
      value: 'Adult',
    },
    {
      key: roles.participant,
      value: 'Participant',
    },
  ];

  statusFilterList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    'groupId': {},
    'session': {},
    'status': {},
    'searchText': {},
    'searchGroup': {},
  }
  form = new FormGroup({
    groupId: new FormControl(null),
    role: new FormControl([roles.participant]),
    session: new FormControl(1),
    status: new FormControl(null),
    searchText: new FormControl(null),
    searchGroup: new FormControl(''),
  })
  clientOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };
  groupOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };
  clientId: any;
  private readonly OnDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private adminGroupListService: AdminGroupListService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.store.dispatch(FetchUserStatusListFilterRequest())
  }

  ngOnInit() {
    this.clientId = this.activatedRoute.snapshot.paramMap.get('clientId');
    this.fetchGroupFilterList();

    const {searchGroup, ...filters} = this.form.getRawValue();
    this.adminGroupListService.onParticipantWeightInformationFilterChange.next(filters);

    this.store.select(groupListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.groupOptions.list.push(...data?.list || []);
        this.groupOptions.hasNext = data?.hasNext
        this.groupOptions.loading = data?.loading;
      });

    this.form.controls.searchGroup.valueChanges
      .pipe(debounceTime(1000), takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.groupOptions.pageNumber = 1;
        this.groupOptions.list = [];
        this.fetchGroupFilterList();
      });

    this.store.select(userStatusListFilter)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe((data) => {
        this.statusFilterList = data.list;
      });
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const {searchGroup, ...filters} = this.form.getRawValue();
    this.adminGroupListService.onParticipantWeightInformationFilterChange.next(filters);
  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  fetchGroupFilterList() {
    const payload: any = {
      pageNumber: this.groupOptions?.pageNumber,
      limit: this.groupOptions?.limit,
      shouldInclude: this.form.value.groupId,
      ...(this.clientId ? {clientId: this.clientId} : {})
    };
    if (this.form.controls?.searchGroup?.value.trim()) {
      payload.search = this.form.controls.searchGroup.value;
    }
    this.store.dispatch(FetchGroupListFilterRequest({payload}));
  }

  groupOnNextPage() {
    this.groupOptions.pageNumber = this.groupOptions.pageNumber + 1
    this.fetchGroupFilterList();
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

}
